export const ID = 'SG40'
